import {Component, EventEmitter, Input, Output} from '@angular/core';

import {FEDERAL_STATES, INSTITUTION_KINDS, TOPIC_KINDS} from '../../../core/constants';
import {ArticlesFilter} from '../../../core/models/articles/articles.filter';
import {Topic} from '../../../core/models/topics/topics.model';
import {User} from "../../../core/models/users/users.model";

@Component({
  selector: 'app-article-filter',
  templateUrl: './article-filter.component.html',
  styleUrls: ['./article-filter.component.css'],
  standalone: false,
})
export class ArticleFilterComponent {
  @Input() topics: Topic[] = [];
  @Input() subjectAreas: Topic[] = [];
  @Input() isAdmin = false;
  @Input() numberOfArticles = 0;
  @Input() articlesFilter: ArticlesFilter = {only: '', topicFilterType: 'and'};
  @Input() user?: User;
  @Output() applied = new EventEmitter<ArticlesFilter>();

  protected readonly TOPIC_KINDS = TOPIC_KINDS;
  protected readonly FEDERAL_STATES = FEDERAL_STATES;
  protected readonly INSTITUTION_KINDS = INSTITUTION_KINDS;

  applyFilter(keydownEvent?: KeyboardEvent) {
    if (keydownEvent && keydownEvent.key !== 'Enter') {
      return;
    }

    this.applied.emit(this.articlesFilter);
  }

  applyNewsletterSettings(){
    this.articlesFilter.topics = this.user?.abonnement?.topics;
    this.articlesFilter.subjectAreas = this.user?.abonnement?.subjectAreas;
    this.articlesFilter.topicFilterType = 'or'
    this.articlesFilter.only = 'onlyCurrent'
  }

  resetFilter() {
    this.articlesFilter.only = '';
    this.articlesFilter.q = undefined;
    this.articlesFilter.topics = undefined;
    this.articlesFilter.subjectAreas = undefined;
    this.articlesFilter.federalStates = undefined;
    this.articlesFilter.topicFilterType = 'and';
    this.articlesFilter.institutionKinds = undefined;
    this.applied.emit(this.articlesFilter);
  }

  switchTopicFilterType() {
    this.articlesFilter.topicFilterType = this.articlesFilter.topicFilterType === 'and' ? 'or' : 'and';
  }

  protected readonly $localize = $localize;
}
